export const getEPRDefaultValue = (
  itemId,
  index,
  existingData,
  type = "value"
) => {
  if (!existingData) return null;

  switch (itemId) {
    case 1:
      return index === 0
        ? existingData.is_symbiotic
          ? "Yes"
          : "No"
        : existingData.is_purchase_all_production
        ? "Yes"
        : "No";

    case 2:
      return index === 0
        ? existingData.is_leased_fuel
          ? "Yes"
          : "No"
        : existingData.fuel_leased_vehicle?.toString() || null;

    case 3:
      return index === 0
        ? existingData.ghg_compliance
          ? "Yes"
          : "No"
        : existingData.ghg_compliance_percentage?.toString() || null;

    case 4:
      return index === 0
        ? existingData.is_leased_fuel_combustion
          ? "Yes"
          : "No"
        : existingData.fuel_leased_combustion?.toString() || null;

    case 5:
      return index === 0
        ? existingData.is_combustion_ghg_compliance
          ? "Yes"
          : "No"
        : existingData.combustion_ghg_compliance?.toString() || null;

    case 6:
      return index === 0
        ? existingData.is_leased_refrigerant
          ? "Yes"
          : "No"
        : existingData.leased_proportion_refrigerant?.toString() || null;

    case 7:
      return existingData.leased_proportion_suppresant?.toString() || null;

    case 8: // Incoming transport
    case 9: // Outgoing transport
    case 10: // Travel transport
      const transportCategory =
        itemId === 8 ? "incoming" : itemId === 9 ? "outgoing" : "travel";

      const transportModes = existingData.transport_modes
        ?.filter((mode) => mode.category === transportCategory)
        ?.sort(
          (a, b) =>
            ["car", "van", "truck", "train", "plane", "ship"].indexOf(a.mode) -
            ["car", "van", "truck", "train", "plane", "ship"].indexOf(b.mode)
        );

      return transportModes
        ? transportModes.map((mode) => mode.percentage.toString())
        : null;

    case 11:
      return (
        existingData.surplus_materials
          ?.sort(
            (a, b) =>
              ["landfill", "recycling", "incineration", "compost"].indexOf(
                a.mode
              ) -
              ["landfill", "recycling", "incineration", "compost"].indexOf(
                b.mode
              )
          )
          ?.map((material) => material.percentage.toString()) || null
      );

    default:
      return null;
  }
};
